// src/constants/churches.ts
export const churches: Array<string> = [
  "Yucaipa",
  "Yucaipa Spanish",
  "Calimesa",
  "Unaffiliated",
];

export function getChurchOptions() {
  return churches.map((value) => ({
    value,
    label: value,
  }));
}